export default function (data) {
  let name = ["未接种", "接种1次", "接种2次", "接种3次"];
  return {
    title: {
      text: "",
      textStyle: {
        color: "#fff",
        fontSize: 16,
      },
    },
    backgroundColor: "",
    tooltip: {
      trigger: "item",
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: "line", // 默认为直线，可选为：'line' | 'shadow'
      },
      textStyle: {
        fontSize: 16,
      },
    },
    legend: {
      x: "right",
      y: "top",
      // left: "right",
      // top: "5%",
      show: true,
      type: "scroll",
      itemWidth: 10,
      itemHeight: 10,
      itemGap: 20,
      data: ["员工", "老人"],
      textStyle: {
        fontSize: 12,
        color: "#fff",
        fontFamily: "Microsoft YaHei",
      },
    },
    grid: [
      {
        left: "5%",
        right: "53%",
        top: 20,
        bottom: "0",
      },
      {
        left: "60%",
        right: "10%",
        top: 20,
        bottom: "0",
      },
      {
        left: "80%",
        right: "100%",
        top: 20,
        bottom: "0",
      },
    ],
    xAxis: [
      {
        type: "value",
        gridIndex: 0,
        inverse: true,
        // padding:[20,20,20,20],
        axisLine: {
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "red",
          },
        },
        splitLine: {
          show: false,
          lineStyle: {
            type: "dotted",
            color: "#ccc",
            width: 1,
          },
        },
        axisTick: {
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "#fff",
          },
        },
        axisLabel: {
          show: false,
          fontFamily: "Microsoft YaHei",
          fontSize: 20,
          color: "fff",
          interval: "auto",
          rotate: "0",
        },
        data: [],
      },
      {
        type: "value",
        gridIndex: 1,
        inverse: false,
        axisLine: {
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "red",
          },
        },
        splitLine: {
          show: false,
          lineStyle: {
            type: "dotted",
            color: "red",
            width: 1,
          },
        },
        axisTick: {
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "red",
          },
        },
        axisLabel: {
          show: false,
          fontFamily: "Microsoft YaHei",
          fontSize: 12,
          color: "#fff",
          interval: "auto",
          rotate: "0",
        },
        data: name,
      },
      {
        type: "value",
        gridIndex: 2,
        inverse: false,
        axisLine: {
          //只有这个
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "red",
          },
        },
        splitLine: {
          show: false,
          lineStyle: {
            type: "dotted",
            color: "#ccc",
            width: 1,
          },
        },
        axisTick: {
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "red",
          },
        },
        axisLabel: {
          show: false,
          fontFamily: "Microsoft YaHei",
          fontSize: 12,
          color: "red",
          interval: "auto",
          rotate: "0",
        },
        data: name,
      },
    ],
    yAxis: [
      {
        type: "category",
        axisLine: {
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "#fff",
          },
        },
        splitLine: {
          show: false,
          lineStyle: {
            type: "dotted",
            color: "#ccc",
            width: 1,
          },
        },
        axisTick: {
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "#888888",
          },
        },
        axisLabel: {
          show: true,
          fontFamily: "Microsoft YaHei",
          fontSize: 10,
          color: "#fff",
          interval: "auto",
        },
        // "data": ['20岁以下', '20-30岁', '30-40岁', '40-50岁', '50-60岁', '60岁以上'],
        data: name,
        position: "right",
      },
      {
        type: "category",
        gridIndex: 1,
        axisLine: {
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "#fff",
          },
        },
        splitLine: {
          show: false,
          lineStyle: {
            type: "dotted",
            color: "#fff",
            width: 1,
          },
        },
        axisTick: {
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "#888888",
          },
        },
        axisLabel: {
          show: false,
          fontFamily: "Microsoft YaHei",
          fontSize: 12,
          color: "#fff",
          interval: "auto",
        },
        data: [],
      },
      {
        type: "category",
        gridIndex: 2,
        axisLine: {
          show: false,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "#fff",
          },
        },
        splitLine: {
          show: false,
          lineStyle: {
            type: "dotted",
            color: "#ccc",
            width: 1,
          },
        },
        axisTick: {
          show: true,
          lineStyle: {
            width: 1,
            type: "solid",
            color: "#888888",
          },
        },
        axisLabel: {
          show: true,
          fontFamily: "Microsoft YaHei",
          fontSize: 20,
          color: "#fff",
          interval: "auto",
        },
      },
    ],
    series: [
      {
        colId: "col402utokg",
        type: "bar",
        name: "员工",
        //  type: 'pictorialBar',
        //  symbol: 'images', //可以使用自定义图片作为柱状图形
        //  symbol: 'image://' + BASE_PATH + '/pages/transportation/pages/supply/img/qianlvzz.png',
        stack: null,
        data: data,
        barWidth: 10,
        barCategoryGap: 20,
        color: "#00f3df",
        xAxisIndex: 0,
        yAxisIndex: 0,
        label: {
          position: "left",
          fontFamily: "Microsoft YaHei",
          show: true,
          fontSize: 12,
          color: "#fff",
        },
      },
      {
        colId: "col3kkgr6h9",
        type: "bar",
        name: "老人",
        //  type: 'pictorialBar',
        //  symbol: 'images',  //可以使用自定义图片作为柱状图形
        //  symbol: 'image://' + BASE_PATH + '/pages/transportation/pages/supply/img/qianlanzz.png',
        stack: null,
        data: [333, 556, 444, 66],
        barWidth: 10,
        color: "#01b3e0",
        xAxisIndex: 1,
        yAxisIndex: 1,
        label: {
          position: "right",
          fontFamily: "Microsoft YaHei",
          show: true,
          fontSize: 12,
          color: "#fff",
        },
      },
    ],
  };
}
